import * as React from "react";
const SvgFiRrMapMarkerCross = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="m8.337 13.323 2.286-2.287L8.337 8.75a.997.997 0 1 1 1.41-1.41l2.286 2.286L14.32 7.34a.997.997 0 1 1 1.41 1.41l-2.287 2.286 2.287 2.287a.997.997 0 1 1-1.41 1.41l-2.287-2.287-2.286 2.287a.997.997 0 0 1-1.41-1.41m-4.031 5.496C-.03 14.588-.113 7.643 4.119 3.309c4.23-4.335 11.175-4.419 15.51-.188l.16.16c4.283 4.283 4.283 11.228 0 15.51l-3.98 3.68a5.427 5.427 0 0 1-7.572-.02zm-1.247-7.783a8.91 8.91 0 0 0 2.629 6.346l3.923 3.625a3.505 3.505 0 0 0 4.823.02l3.973-3.672A8.974 8.974 0 1 0 5.687 4.691a8.91 8.91 0 0 0-2.628 6.345"
    />
  </svg>
);
export default SvgFiRrMapMarkerCross;
